module.exports = __webpack_public_path__ + "img/bobo-w.d346d8e5.png";